var path = 'modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html';
var html = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n    uib-modal-animation-class=\"fade\"\n    modal-in-class=\"in\"\n    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n    <div class=\"modal-dialog portlet modal-large\" uib-modal-transclude></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/dc-ui/dc-modal/&prefix=modules/dc-ui/dc-modal/!./~/raw-loader!./src/ui/modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html
// module id = 881
// module chunks = 12